<template>
	<div class="type-components">
		<ul>
			<li v-for="item in types" :key="item.id">
				<div class="menu-content" @click="goTypes(item.categoryId);">
					<div class="img-box"><img :src="item.icon" width="16" height="17" /></div>
					<div class="name">{{ item.name }}</div>
					<div class="menu-icon-box"><i slot="prefix" class="el-input__icon el-icon-arrow-right"></i></div>
				</div>
				<div class="type-bg-box" v-if="item.childList.length > 0">
					<div class="type-box">
						<!-- 占位，顶部没有内容时，margin属性会把父元素往下挤 -->
						<div class="seat"></div>
						<div class="label-box">
							<div class="label" v-for="label in item.childList" :key="label.id"
								@click="goTypes(item.categoryId, label.categoryId);">{{ label.name }}</div>
						</div>
						<div class="seat"></div>
					</div>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
	import {
		getAllTypes
	} from '@/api/goods.js';

	export default {
		name: "type-components",
		data() {
			return {
				types: []
			}
		},
		created() {
			this.getAllTypes()
		},
		watch: {
			'$store.state.userInfo.groupId'(val) {
				getAllTypes().then(res => {
					if (res && res.data) {
						this.types = res.data;
						window.sessionStorage.setItem('productTypes', JSON.stringify(this.types));
					}
				});
			},
			'$store.state.hasLogin'(val) {
				this.getAllTypes()
			}
		},
		methods: {
			getAllTypes() {
				if (window.sessionStorage.getItem('productTypes')) {
					this.types = JSON.parse(window.sessionStorage.getItem('productTypes'));
				} else {
					getAllTypes().then(res => {
						if (res && res.data) {
							this.types = res.data;
							window.sessionStorage.setItem('productTypes', JSON.stringify(this.types));
						}
					});
				}
			},
			goTypes(categoryCode, categoryCode2) {
				let url = '/goodsList?pageFrom=types&categoryCode=' + categoryCode;

				if (categoryCode2) {
					url = url + '&categoryCode2=' + categoryCode2
				}
				this.$router.push(url);
			}
		}
	};
</script>

<style lang="scss" rel="stylesheet/scss">
	@import "@/assets/css/szui.scss";

	.type-components {
		position: relative;
		padding: 15px 0;
		width: 230px;
		height: 386px;
		background: #FFFFFF;
		border-radius: 10px;
		box-sizing: border-box;

		ul::-webkit-scrollbar {
			width: 0;
			height: 0;
		}

		ul {
			margin: 0px;
			padding: 0px;
			height: 100%;
			list-style: none;
			overflow: scroll;

			li {
				padding: 0 10px;
				cursor: pointer;

				.menu-content {
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding: 15px 10px;
					width: 210px;
					height: 44.3px;
					border-radius: 8px;
					box-sizing: border-box;

					.img-box {
						flex-shrink: 0;
						width: 16px;
						height: 16px;

						img {
							width: 100%;
							height: 100%;
						}
					}

					.name {
						flex: 1;
						margin-left: 12px;
					}

					.menu-icon-box {
						flex-shrink: 0;

						.el-icon-arrow-right {
							font-weight: bold;
							font-size: 8px;
							color: #C0C4CC;
						}
					}
				}

				.type-bg-box {
					position: absolute;
					top: 0;
					left: 230px;
					z-index: 11;
					display: none;
					background-color: #F8F8F8;
					padding-left: 10px;

					.type-box {
						width: 720px;
						height: 386px;
						background: #FFFFFF;
						border-radius: 10px;
						box-sizing: border-box;

						.seat {
							height: 20px;
						}

						.label-box::-webkit-scrollbar {
							width: 0;
							height: 0;
						}

						.label-box {
							display: flex;
							justify-content: flex-start;
							align-items: flex-start;
							flex-wrap: wrap;
							width: 100%;
							max-height: calc(100% - 40px);
							box-sizing: border-box;
							overflow: scroll;

							.label {
								padding: 10px 40px 10px 30px;
								width: 25%;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
								cursor: pointer;
							}

							.label:hover {
								text-decoration: underline;
							}
						}
					}
				}
			}

			li:hover {
				.menu-content {
					background: #F5F7FA;

					.menu-icon-box {
						flex-shrink: 0;

						.el-icon-arrow-right {
							color: $fontColor;
						}
					}
				}

				.type-bg-box {
					display: block;
				}
			}
		}
	}
</style>